import { redirect } from "../utils/redirect.ts";

<!doctype html>
<html lang="en">
  <head>
    <meta charset="UTF-8">
    <link rel="icon" type="image/png" sizes="32x32" href="./favicon.png">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <meta name="description" content="A basic Marko app.">
    <title>LAMig-SALN App</title>
    <link rel="manifest" href="manifest.json">
    <!--iOS-->
    <link rel="apple-touch-icon" href="/icons/fire.png">
    <meta name="apple-mobile-web-app-status-bar" content="#f7df1e">
    <meta name="theme-color" content="#f7df1e">
  </head>
  <body>
    <${input.content}/>
  </body>
</html>

// Script for registering service worker
<script>
  if ("serviceWorker" in navigator && "SyncManager" in window) {
    window.addEventListener("load", async () => {
      try {
        const registration = await navigator.serviceWorker.register("/service-worker.js");
        console.log("Service Worker registered:", registration);

        // Wait until the service worker is fully active
        const readyReg = await navigator.serviceWorker.ready;
        await readyReg.sync.register("sync-requests");
        console.log("Background sync registered (sync-requests)");
      } catch (err) {
        console.error("Service Worker registration failed:", err);
      }
    });
  } else {
    console.warn("Background Sync not supported — fallback will be used");
  }
</script>

// Script for page access redirects
<script>
  console.log("HELLO FROM MAIN");
  // localStorage.setItem("employeeID", "1234");
  const employeeID = localStorage.getItem("employeeID");
  const sessionEmail = sessionStorage.getItem("email");
  const currentPath = window.location.pathname;

  if (!employeeID) {
    if (
      ((currentPath === "/otp-verification" && !sessionEmail) || currentPath !== "/otp-verification") &&
      currentPath !== "/"
    ) {
      redirect("/");
    }
  } else {
    if (
      currentPath === "/" || 
      currentPath === "/otp-verification"
    ) {
      redirect("/dashboard");
    }
  }
</script>

<style>
  html,
  body {
    font-family: system-ui;
    padding: 0;
    margin: 2%;
    height: 100%;
    color: #fff;
    background: #E5E5E0;
  }
</style>
